import { useEffect, useState } from "react"
import { MdClose } from "react-icons/md"
import { FiPlus } from "react-icons/fi"
import { useSelector } from "react-redux"

// Defining a functional component ChipInput
export default function ChipInput({
  // Props to be passed to the component
  label,
  name,
  placeholder,
  register,
  errors,
  setValue,
  getValues,
}) {
  const { editCourse, course } = useSelector((state) => state.course)

  // Setting up state for managing chips array
  const [chips, setChips] = useState([])

  useEffect(() => {
    if (editCourse) {
      // console.log(course)
      setChips(course?.tag)
    }
    register(name, { required: true, validate: (value) => value.length > 0 })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setValue(name, chips)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chips])

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault()
      const chipValue = event.target.value.trim()
      if (chipValue && !chips.includes(chipValue)) {
        setChips([...chips, chipValue])
        event.target.value = ""
      }
    }
  }

  const handleAdd = (inputEl) => {
    const val = inputEl?.value?.trim()
    if (val && !chips.includes(val)) {
      setChips([...chips, val])
      inputEl.value = ""
      inputEl.focus()
    }
  }

  const handleDeleteChip = (chipIndex) =>
    setChips(chips.filter((_, index) => index !== chipIndex))

  return (
    <div className="flex flex-col gap-1.5">
      <label className="text-sm font-medium text-richblack-5" htmlFor={name}>
        {label} <sup className="text-pink-200">*</sup>
      </label>

      {/* Chips */}
      {chips.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {chips.map((chip, index) => (
            <div
              key={index}
              className="flex items-center gap-1.5 rounded-full border border-yellow-400/30 bg-yellow-400/20 px-3 py-1 text-sm text-yellow-50"
            >
              {chip}
              <button
                type="button"
                onClick={() => handleDeleteChip(index)}
                className="flex-shrink-0 rounded-full text-yellow-50/70 transition-colors hover:text-yellow-50"
              >
                <MdClose size={14} />
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Input */}
      <div className="relative">
        <input
          id={name}
          name={name}
          type="text"
          placeholder={placeholder}
          onKeyDown={handleKeyDown}
          className="form-style w-full !pr-10"
        />
        <button
          type="button"
          title="Add tag"
          onClick={(e) =>
            handleAdd(e.currentTarget.closest(".relative").querySelector("input"))
          }
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-richblack-400 transition-colors hover:text-yellow-50"
        >
          <FiPlus size={18} />
        </button>
      </div>

      {errors[name] && (
        <p className="flex items-center gap-1 text-xs text-pink-200">
          <span>⚠</span> {label} is required
        </p>
      )}
    </div>
  )
}